var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.UserLanding,{tag:"component",attrs:{"default-filters":_vm.defaultFiltersComputed,"default-pagination":_vm.defaultPagination,"current-pagination":_vm.paginationComputed,"search-input":_vm.searchInput},on:{"change-pagination":function($event){return _vm.changePagination($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }